module.exports = __webpack_public_path__ + "fd66d1bcd87ad6fa9b9ea99d01f9d61c.svg";